export async function triggerDownloadFromUrl(url, filename = 'download') {
  if (!url) {
    throw new Error('Missing download URL');
  }

  const response = await fetch(url, { mode: 'cors' });
  if (!response.ok) {
    throw new Error('Unable to fetch file');
  }

  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } finally {
    window.URL.revokeObjectURL(blobUrl);
  }
}

export default {
  triggerDownloadFromUrl,
};
